// extracted by mini-css-extract-plugin
module.exports = {"tabButton":"TabButton_tabButton__3v6v6","tabButtonSelected":"TabButton_tabButtonSelected__2E0Gm"};